export enum BusinessType {
  OWNER = 'OWNER',
  BUILDER = 'BUILDER',
  SUPPLIER = 'SUPPLIER',
  SUBCONTRACTOR = 'SUBCONTRACTOR',
  SUPERINTENDENT = 'SUPERINTENDENT',
  FUNDER = 'FUNDER',
  QUANTITY_SURVEYOR = 'QUANTITY_SURVEYOR',
}

export enum TrustType {
  INDIVIDUAL = 'INDIVIDUAL',
  COMPANY = 'COMPANY',
}

export enum TrusteeType {
  COMPANY_TRUSTEE = 'COMPANY_TRUSTEE',
  INDIVIDUAL_TRUSTEE = 'INDIVIDUAL_TRUSTEE',
}

export enum BusinessStructure {
  COMPANY = 'COMPANY',
  SOLE_TRADER = 'SOLE_TRADER',
  PARTNERSHIP = 'PARTNERSHIP',
  TRUST = 'TRUST',
  OTHER = 'OTHER',
}
